import { Grid, ShoppingCart, User, CreditCard, Gift, Briefcase, PlusCircle, HelpCircle } from "react-feather"
import { BsTicket } from "react-icons/bs"
import { FaAddressBook } from "react-icons/fa";
import { RiCoupon2Line } from "react-icons/ri";
import { MdOutlineReviews } from "react-icons/md";
import { GiLargeDress } from "react-icons/gi";

export default [
  {
    id: "User",
    title: "Dashboard",
    icon: <Grid size={20} />,
    navLink: "/dashboard"
  },
  {
      id: "UserProfile",
      title: "My Profile",
      icon: <User size={20} />,
      navLink: "/user-profile"
},
  {
      id: "AddressBook",
      title: "Address Book",
      icon: <FaAddressBook size={20} />,
      navLink: "/address-book"
},
  {
      id: "PaymentInfo",
      title: "Payment Info",
      icon: <CreditCard size={20} />,
      navLink: "/payment-info"
},
  {
      id: "Orders",
      title: "Orders",
      icon: <ShoppingCart size={20} />,
      navLink: "/orders"
},
  {
      id: "CouponsVouchers",
      title: "Coupons Vouchers",
      icon: <RiCoupon2Line size={20} />,
      navLink: "/coupons-vouchers"
},
  {
      id: "MyReviews",
      title: "My Reviews",
      icon: <MdOutlineReviews size={20} />,
      navLink: "/myreviews"
},
  {
      id: "MyActivity",
      title: "My Activity",
      icon: <PlusCircle size={20} />,
      navLink: "/my-activity"
},
{
  id: "jobApplication",
  title: "Job Applications",
  icon: <Briefcase size={20} />,
  navLink: "/users/jobApplication"
  //    children: [
  //   {
  //     id: 'smeList',
  //     title: 'List',
  //     icon: <Home />,
  //     navLink: '/sme'
  //   },
  // ]
},

{
  id: "giftCards",
  title: "Gift Cards",
  icon: <Gift size={20} />,
  navLink: "/users/giftCards"
},
  {
      id: "maestyle",
      title: "Mae Style",
      icon: <GiLargeDress size={20} />,
      navLink: "/maestyle"
},
  {
      id: "tickets",
      title: "Tickets",
      icon: <BsTicket size={20} />,
      navLink: "/users/tickets"
},
{
      id: "customerService",
      title: "Customer Services",
      icon: <HelpCircle size={20} />,
      navLink: "/customer-services-section"
},

 
]



// import React from "react";

// import {useSelector} from 'react-redux'

// import {
//   Mail,
//   Home,
//   Map,
//   Book,
//   BarChart2,
//   Circle,
//   Sliders,
//   Plus,
//   PieChart,
//   Disc,
//   Tag,
//   User,
//   Users
// } from "react-feather"
// import { handleNavigation } from "../../redux/navigation";
// import { store } from "../../redux/store";
// import { HiOutlineTicket } from "react-icons/hi";
// import { MdOutlineTopic } from "react-icons/md";
// import { CiSettings } from "react-icons/ci";
// import { IoLanguage } from "react-icons/io5";
// import { LuMessagesSquare } from "react-icons/lu";
// import { FaMoneyBill } from "react-icons/fa";
// import { SlBadge } from "react-icons/sl";
// import { LuBuilding2 } from "react-icons/lu";
// import { GrUserManager } from "react-icons/gr";
// import { TbTemplate } from "react-icons/tb";
// import { IoNotificationsOutline } from "react-icons/io5";

// const defaultNavigation = [
//   {
//       id:'Home',
//       title:'Home',
//       icon:<Home size={12} />,
//       navLink:'/home'
     
//   }
// ]

// // Generate navigation based on the provided data
// // const generateNavigation = (data) => {
// //   const dataArray = Object.values(data);
// //   const mappedArray = dataArray.map((item, index) => ({
// //     id: item.page_name,
// //     title: item.page_name,
// //     icon: React.createElement(getIconComponent(item.icon), { size: 20 }),
// //     navLink: item.route_path,
// //   }));
// //   return mappedArray;
// // };

// const iconList={

//   "home":<Home/>,
//   "enterprises":<Home/>,
//   "user_management":<Users/>,
//   "indv_management":<User />,
//   "sub_management":<HiOutlineTicket />,
//   "title_sme":<MdOutlineTopic />,
//   "setting":<CiSettings />,
//   "languages":<IoLanguage />,
//   "chatboard":<LuMessagesSquare />,
//   "charity":<FaMoneyBill />,
//   "reward_management":<SlBadge />,
//   "entp_management":<LuBuilding2 />,
//   "sme_management":<GrUserManager />,
//   "schedule_templates":<TbTemplate />,
//   "notifications":<IoNotificationsOutline />,


// }

// async function filterNavigation(data) {
//   // console.log('navigation data: ', data)
//   store.dispatch(handleNavigation(data))
//   let nav=[]
//   let allNav=[]

//   for(let i=0;i<data?.length;i++){

//       let currentNode=data[i]

     
//       let obj={}

//       obj.id=currentNode?.id
//       obj.title=currentNode?.page_name
//       obj.navLink=currentNode?.route
//       obj.icon=iconList[currentNode.page_key] || <Disc/>

//       obj.navLink!='' && allNav.push(obj.navLink)

//       if(currentNode?.children?.length>0){

//           const childArr=currentNode.children

//           let children=childArr.map(group=>{

//               let childObj={}

//               childObj.id=group.id
//               childObj.title=group.page_name
//               childObj.navLink=group.route
//               childObj.icon=iconList[group.page_name] || <Disc/>
              
//               childObj.navLink!='' && allNav.push(childObj.navLink)

//               if(group?.children?.length>0){

//                   let gChildArr=group.children

//                   let gChildren=gChildArr.map(groupSection=>{

//                       let gChildObj={}
      
//                       gChildObj.id=groupSection.id
//                       gChildObj.title=groupSection.page_name
//                       gChildObj.navLink=groupSection.route
//                       gChildObj.icon=iconList[groupSection.page_name] || <Circle/>

//                       gChildObj.navLink!='' && allNav.push(gChildObj.navLink)

//                       return gChildObj
//                   })
                  
//                   childObj.children=gChildren

//               }

//               return childObj
//           })
//           obj.children=children

//       }
//       nav.push(obj)
//   }
//   allNav.unshift('/home')
//   localStorage.setItem("navLinks",JSON.stringify(allNav))

//   return nav

// }
// export const getNavigation = async () => {
//   const navigationData = localStorage.getItem('navigation')

//   if (
//     navigationData != 'undefined' &&
//     navigationData != null &&
//     navigationData.length != 0
//   ) {
//     // console.log("HEHE!")
//     const filteredNavigation = await filterNavigation(JSON.parse(navigationData));
//     return filteredNavigation;
//   }
//   // console.log("HEHE2")
//   return defaultNavigation;
// };
// // export default generateNavigation;